// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../common/temp/node_modules/.pnpm/@rsbuild+core@1.1.14/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ui-table-meta-SiVETU{align-items:center;width:100%;height:40px;display:flex}.ui-table-meta-SiVETU .table-name-ARFJ08{flex:1;margin-left:16px}.ui-table-meta-SiVETU .meta-avatar-UYxGlN{border-radius:6px;flex-shrink:0;width:36px;height:36px;margin-right:16px}.ui-table-meta-SiVETU .meta-right-QIkpIY{width:100%}.ui-table-meta-SiVETU .meta-right-width-g3VLg2{width:calc(100% - 32px)}.ui-table-meta-SiVETU .meta-name-zw8r2v{white-space:nowrap;text-overflow:ellipsis;color:var(--light-usage-text-color-text-0,#1c1d23);font-size:14px;font-weight:700;line-height:22px;overflow:hidden}.ui-table-meta-SiVETU .meta-description-uBVcJU{word-break:break-word;text-overflow:ellipsis;-webkit-line-clamp:1;color:var(--light-usage-text-color-text-1,rgba(28,29,35,.8));-webkit-box-orient:vertical;margin-top:2px;font-size:12px;font-weight:400;line-height:22px;display:-webkit-box;overflow:hidden}.ui-table-meta-SiVETU .meta-suffix-bLV01s{margin-top:2px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ui-table-meta": `ui-table-meta-SiVETU`,
	"uiTableMeta": `ui-table-meta-SiVETU`,
	"table-name": `table-name-ARFJ08`,
	"tableName": `table-name-ARFJ08`,
	"meta-avatar": `meta-avatar-UYxGlN`,
	"metaAvatar": `meta-avatar-UYxGlN`,
	"meta-right": `meta-right-QIkpIY`,
	"metaRight": `meta-right-QIkpIY`,
	"meta-right-width": `meta-right-width-g3VLg2`,
	"metaRightWidth": `meta-right-width-g3VLg2`,
	"meta-name": `meta-name-zw8r2v`,
	"metaName": `meta-name-zw8r2v`,
	"meta-description": `meta-description-uBVcJU`,
	"metaDescription": `meta-description-uBVcJU`,
	"meta-suffix": `meta-suffix-bLV01s`,
	"metaSuffix": `meta-suffix-bLV01s`
};
export default ___CSS_LOADER_EXPORT___;
